import { Capacitor } from '@capacitor/core';

/**
 * Check if running in a Capacitor/mobile native environment
 * Returns true ONLY when running inside the iOS/Android native app wrapper
 * Returns false when running in a web browser (even mobile browsers)
 */
export const isMobileApp = (): boolean => {
  return Capacitor.isNativePlatform();
};

